import * as React from "react";
import { ILocationTableItem, locationTableItems } from "./TableData";

import { ObservableValue } from "azure-devops-ui/Core/Observable";
import { Card } from "azure-devops-ui/Card";
import { Link } from "azure-devops-ui/Link";
import {
    ITableColumn,
    renderSimpleCell,
    Table,
    TwoLineTableCell,
} from "azure-devops-ui/Table";
import { ArrayItemProvider } from "azure-devops-ui/Utilities/Provider";

export default class TableExample extends React.Component {
    public render(): JSX.Element {
        return (
            <Card className="flex-grow bolt-table-card" contentProps={{ contentPadding: false }}>
                <Table<Partial<ILocationTableItem>>
                    ariaLabel="Table with links"
                    className="table-example"
                    columns={locationColumns}
                    containerClassName="h-scroll-auto"
                    itemProvider={tableItemProvider}
                    singleClickActivation={false}
                    onActivate={(event, data) => console.log("Activate Row - " + data.index)}
                />
            </Card>
        );
    }
}

const locationColumns = [
    { id: "name", name: "Name", renderCell: renderName, width: new ObservableValue(-40) },
    {
        id: "continent",
        name: "Continent",
        renderCell: renderSimpleCell,
        width: new ObservableValue(-20),
    },
    {
        id: "server",
        name: "Server",
        readonly: true,
        renderCell: renderSimpleCell,
        width: new ObservableValue(-40),
    },
];

const tableItemProvider = new ArrayItemProvider<ILocationTableItem>(locationTableItems);

function renderName(
    rowIndex: number,
    columnIndex: number,
    tableColumn: ITableColumn<ILocationTableItem>,
    tableItem: ILocationTableItem
): JSX.Element {
    const { name, city, state, country } = tableItem;
    return (
        <TwoLineTableCell
            className="bolt-table-cell-content-with-inline-link no-v-padding"
            key={"col-" + columnIndex}
            columnIndex={columnIndex}
            tableColumn={tableColumn}
            line1={
                <div className="fontsizeM font-size-m bolt-table-inline-link-left-padding">
                    {name}
                </div>
            }
            line2={
                <>
                    <Link
                        className="fontSizeMS font-size-ms secondary-text bolt-table-link bolt-table-inline-link"
                        excludeTabStop
                        href={"#" + city}
                    >
                        {city},
                    </Link>
                    <Link
                        className="fontSizeMS font-size-ms secondary-text bolt-table-link bolt-table-inline-link"
                        excludeTabStop
                        href={"#" + state}
                    >
                        {state},
                    </Link>
                    <Link
                        className="fontSizeMS font-size-ms secondary-text bolt-table-link bolt-table-inline-link"
                        excludeTabStop
                        href={"#" + country}
                    >
                        {country}
                    </Link>
                </>
            }
        />
    );
}
